import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=24605fa2&scoped=true&"
import script from "./TextView.vue?vue&type=script&lang=js&"
export * from "./TextView.vue?vue&type=script&lang=js&"
import style0 from "./TextView.vue?vue&type=style&index=0&id=24605fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24605fa2",
  null
  
)

export default component.exports